import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const OpeningSection = () => (
    <ScrollableAnchor id="opening">
        <section className="content-section bg-primary text-white text-center animatedParent animateOnce" data-appear-top-offset='-300' data-sequence='500'>
            <div className="container">
                <div className="content-section-heading">
                    <h3 className="text-secondary mb-0">Öffnungszeiten</h3>
                    <h2 className="mb-5">Wann wir für euch da sind</h2>
                </div>
                <div>
                    <div className="animated bounceIn" data-id="1">
                        <h3>Rehasport Erstanmeldung</h3>
                        <h3>Vor Ort, sowie unter Tel: <a className="text-dark" href="callto://+079149385838">0791 / 49385838</a></h3>
                        <h4>Montag</h4>
                        <h5><i>16:00 Uhr bis 20:00 Uhr</i></h5>
                        <h4>Mittwoch</h4>
                        <h5><i>09:00 Uhr bis 14:00 Uhr</i></h5>
                    </div>
                    <br/>
                    <br/>
                    <div className="animated bounceIn" data-id="2">
                        <h3>Termine, Behandlung und sonstige Anliegen</h3>
                        <h3>Vor Ort, sowie unter Tel: <a className="text-dark" href="callto://+079149385838">0791 / 49385838</a></h3>
                        <h4>Montag</h4>
                        <h5><i>16:00 Uhr bis 20:00 Uhr</i></h5>
                        <h4>Mittwoch</h4>
                        <h5><i>09:00 Uhr bis 14:00 Uhr</i></h5>
                    </div>
                    <br/>
                    <div className="animated bounceIn" data-id="3">
                        <h4>Oder</h4>
                        <h4>Per Email: <a className="text-dark" href="mailto:info@medizentrum.life">info@medizentrum.life</a></h4>
                        <h5>Von Montag bis Donnerstag</h5>
                        <h6><i>09:00 Uhr bis 20:00 Uhr</i></h6>
                        <br/>
                        <h6><i>Wir bemühen uns alle Anfragen zeitnah zu beantworten</i></h6>
                    </div>
                </div>
            </div>
        </section>
    </ScrollableAnchor>
);
export default OpeningSection;



// WEBPACK FOOTER //
// ./src/main/opening.js